<button
  (click)="toggle()"
  (keydown)="focusItems($event, true)"
  type="button"
  class="btn dropdown-button dropdown-toggle dropdown-select"
  [ngClass]="[textAlignment, background]"
  [disabled]="disabled"
  #toggleButton
>
  <div class="button-label">
    {{ getLabel() }}

    <span class="indicator" *ngIf="indicator && selectionLength > 0">
      {{ selectionLength }}
    </span>
  </div>
  <span
    *ngIf="selectIcon"
    class="dropdown-button-icon"
    (click)="toggle(); $event.stopPropagation()"
  >
    <ng-container [ngTemplateOutlet]="selectIcon.template"></ng-container>
  </span>
</button>

<div class="dropdown">
  <ul class="dropdown-menu user_list_dropdown_menu" [class.show]="isOpen">
    <!-- HEADER  -->
    <div class="header-group input-group-text template_search">
      <div class="title-close">
        <div class="header-left-content file-select">
          <button
            *ngIf="!isRootFolder"
            class="btn btn-outline-default dropdown-input-decorators no-box-shadow"
            type="button"
            (click)="goBack($event)"
          >
            <i id="go-back-btn" class="fa fa-arrow-left" aria-hidden="true"></i>
          </button>
          {{
            isRootFolder
              ? folderOption.headerLabel
              : selectedFolder[folderOption.displayKey]
          }}
        </div>
        <button
          *ngIf="isRemoveSelection"
          class="btn btn-outline-default dropdown-input-decorators no-box-shadow"
          type="button"
          (click)="remove($event)"
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <!-- SEARCH -->
      <div
        class="input-group input-group-sm"
        *ngIf="enableSearch"
        #searchContainer
      >
        <span class="input-group-text">
          <i class="fa fa-search" aria-hidden="true"></i>
        </span>
        <input
          type="text"
          class="form-control"
          placeholder="Search"
          [formControl]="searchText"
          (keydown)="focusItems($event, false, true)"
          #searchInput
        />
        <button
          *ngIf="clearSearch"
          class="btn btn-outline-default dropdown-input-decorators no-box-shadow"
          type="button"
          (click)="emptySearch()"
          (keydown)="focusItems($event, false, true)"
        >
          <i class="fa fa-times-circle" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <ng-container>
      <!-- LIST ITEMS -->
      <ng-container
        *ngIf="
          (
            folderItems
            | searchFilter : searchText.value : folderOption.displayKey
          )?.length ||
            (
              fileItems
              | searchFilter : searchText.value : fileOption.displayKey
            )?.length;
          else noData
        "
      >
        <div
          *ngFor="
            let item of folderItems
              | searchFilter : searchText.value : folderOption.displayKey;
            let i = index
          "
        >
          <li class="list-item">
            <input
              type="checkbox"
              (click)="selectFiles(item, 'folder', $event)"
              [checked]="isFolderChecked(item)"
              *ngIf="multi"
              class="list-checkbox"
            />

            <span
              id="parent-item"
              (click)="selectFolderItem(item, $event)"
              class="list-item dropdown-item left-padding"
            >
              <div class="list-item-group-1">
                <i
                  *ngIf="folderOption.icon"
                  class="{{ folderOption.icon }}"
                  aria-hidden="true"
                  (click)="selectFolderItem(item, $event)"
                ></i>

                {{ item[folderOption.displayKey] }}
              </div>
              <div class="list-item-group-2">
                <button
                  class="btn btn-outline-default dropdown-input-decorators no-box-shadow"
                  type="button"
                  *ngIf="folderOption.removeItem"
                >
                  <i (click)="deleteFolder(i, $event)" class="fa fa-trash"> </i>
                </button>
                <button
                  class="btn btn-outline-default dropdown-input-decorators no-box-shadow delete-template"
                  (click)="deleteTemplate(item, $event, 'folder')"
                  *ngIf="item.deletable"
                >
                  <i aria-hidden="true" class="fa fa-trash"> </i>
                </button>

                <i
                  class="fa fa-caret-right right-arrow-icon"
                  aria-hidden="true"
                  *ngIf="showFolderArrowIcon"
                ></i>
              </div>
            </span>
          </li>
        </div>
        <div
          *ngFor="
            let item of fileItems
              | searchFilter : searchText.value : fileOption.displayKey;
            let i = index
          "
        >
          <li class="list-template">
            <input
              type="checkbox"
              (click)="selectFiles(item, 'file', $event)"
              [checked]="item.isChecked"
              *ngIf="multi"
              class="list-checkbox"
            />

            <span id="parent-item" class="list-item dropdown-item left-padding">
              <div
                class="list-item-group-1 justify-content-between"
                (click)="selectFileItem(item)"
              >
                <i
                  *ngIf="fileOption.icon && !item[fileOption.mcIconIdentifier]"
                  class="{{ fileOption.icon }}"
                  aria-hidden="true"
                ></i>
                <img
                  src="/assets/image/multi-country-icon.png"
                  class="multi-country-icon"
                  *ngIf="item[fileOption.mcIconIdentifier]"
                  alt="item[fileOption.displayKey]"
                />
                {{ item[fileOption.displayKey] }}
                <span
                  class="text-muted"
                  style="margin-left: auto"
                  title="{{
                    item[
                      fileOption.mcIconIdentifier
                        ? fileOption.mcIconIdentifier
                        : ''
                    ]
                      ? 'Multi-country template'
                      : 'Single country template'
                  }}"
                  >{{
                    item[
                      fileOption.mcIconIdentifier
                        ? fileOption.mcIconIdentifier
                        : ''
                    ]
                      ? 'MC'
                      : 'SC'
                  }}</span
                >
              </div>
              <div class="list-item-group-2">
                <button
                  class="btn btn-outline-default dropdown-input-decorators no-box-shadow delete-template"
                  (click)="deleteTemplate(item, $event, 'template')"
                  *ngIf="item.deletable"
                >
                  <i aria-hidden="true" class="fa fa-trash"> </i>
                </button>
                <button
                  class="btn btn-outline-default dropdown-input-decorators no-box-shadow"
                  type="button"
                >
                  <i
                    *ngIf="fileOption.removeItem"
                    (click)="deleteFile(i, $event)"
                    class="fa fa-trash"
                  >
                  </i>
                </button>
              </div>
            </span>
          </li>
        </div>
      </ng-container>
      <ng-template #noData>
        <div class="no-content-box">
          {{ noContentMessage }}
        </div>
      </ng-template>
    </ng-container>

    <div
      *ngIf="addNewFolder && currentDepth <= maxDepth"
      class="new-input-list"
      id="new-input-list"
    >
      <li>
        <ng-container *ngIf="footerInputMode; else noFooterInputMode">
          <span
            class="dropdown-item dropdown-item-selectable footer-input-text"
            id="new-input-list"
          >
            <i
              class="fa fa-times-circle"
              aria-hidden="true"
              (click)="footerInputMode = false"
              id="new-input-remove"
              #newinputemove
            ></i
            ><input
              type="text"
              placeholder="{{ footerInputPlaceholder }}"
              [formControl]="inputItem"
              #folderInput
              (keyup)="removeEmptySpace()"
            />
            <button
              color="secondary"
              (click)="onSaveFolderName($event)"
              id="footer-button"
              #footerbutton
            >
              <i
                class="fa fa-check"
                aria-hidden="true"
                id="footer-button-check"
                #footerbuttoncheck
              ></i>
            </button>
          </span>
        </ng-container>
        <ng-template #noFooterInputMode>
          <span class="d-flex justify-content-around">
            <button
              *ngIf="isFirstFooterButton"
              type="button"
              psUiButton
              color="secondary"
              class="btn footer-button"
              (click)="footerInputMode = true; $event.stopPropagation()"
            >
              {{ footerButtonText }}
            </button>
            <button
              *ngIf="showFooterSelectButton"
              type="button"
              psUiButton
              color="primary"
              class="btn footer-button"
              (click)="onSelectFolder()"
            >
              {{ footerSelectButtonText }}
            </button>
          </span>
        </ng-template>
      </li>
    </div>
  </ul>
</div>
